module.exports = __webpack_public_path__ + "img/pr-8.4d224e83.png";